import * as React from "react";
import { Grid } from "@mui/material";

interface InformationGridProps {
  children: React.ReactNode;
}

/**
 * Responsive card grid: 1 column on mobile, 2 on tablet, 3 on laptop, 4 on
 * desktop/large monitor. Each child is wrapped in its own Grid item.
 */
export function InformationGrid({ children }: InformationGridProps): React.JSX.Element {
  const items = React.Children.toArray(children);
  return (
    <Grid container spacing={3}>
      {items.map((child, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
}
